<script lang="ts" setup>
import { computed } from "vue";

import { useSettingsStore } from "@/stores";
import type { Level } from "@/types/dictionary";

import { mapGrammaticalLabelsToLevel } from "./level-mapping";

defineProps<{
  wordClass: {
    danish: string;
    danishLatin: string;
  };
}>();

const settingsStore = useSettingsStore();
const wordClassLevel = computed<Level>(() => settingsStore.activeWordClassLevel);
</script>

<template>
  <span>{{
    mapGrammaticalLabelsToLevel(wordClassLevel, wordClass.danish, wordClass.danishLatin)
  }}</span>
</template>
